<section>
<!-- navigation -->
  <div class="flex justify-between items-end">
    <div>
      <h1>Dashboard</h1>
    </div>
    <div>
      <select *ngIf="dashboard_filter" class="select select-sm select-bordered w-full max-w-xs ">
        <option>This Year</option>
        <option>Acedmic Year</option>
        <option>Calender Year</option>
        <option>Lifetime</option>
        <option>Custom</option>
      </select>
    </div>
  </div>
<!-- navigation -->
  <!-- mai -->
  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-5 mt-10">

    <div *ngIf="stats" class="col-span-1 md:col-span-2 xl:col-span-4  h-auto lg:h-[20rem]">
        <app-stats-cards></app-stats-cards>
    </div>
    <div *ngIf="communication" class="col-span-1 xl:col-span-2  h-[20rem]">
        <app-chat-box-card [filter]="communication_filter"></app-chat-box-card>
    </div>
    <div *ngIf="top_student" class="col-span-1 xl:col-span-2  h-[20rem]">
        <app-top-student-card [filter]="top_student_filter"></app-top-student-card>
    </div>
    <div *ngIf="platform_usage" class="col-span-1 xl:col-span-2  h-[20rem]">
        <app-platform-useage-card [filter]="platform_usage_filter"></app-platform-useage-card>
    </div>
    <div *ngIf="calender" class="col-span-1 xl:col-span-2  h-[20rem]">
        <app-calender-card></app-calender-card>
    </div>
    <div *ngIf="classroom_syllbus" class="col-span-1 md:col-span-2 xl:col-span-full  h-[20rem]">
        <app-classroom-syllabus-card [filter]="classroom_syllbus_filter"></app-classroom-syllabus-card>
    </div>

    


  </div>
  <!-- mai -->



</section>
